
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#main{
  overflow-y:scroll;
  overflow-x:hidden;
  max-height:75vh;
}

#header {
  position: relative;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 3rem;
}

@media (min-width: 1024px) {

  #header {
    padding-top: 1.5rem;
  }
}

#close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  border-width: 0px;
  background-color: var(--neutral-transparent);
}

@media (min-width: 1024px) {

  #close {
    top: 0.625rem;
  }

  #close {
    right: 1.25rem;
  }
}

#close{
  font-size:1.5rem;
}

`;